var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClaendarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 14.8252V14.75M9.5 14.8252V14.75M9.5 10.75V10.6749M13.5 10.75V10.6749M2 6.75H16M3.80952 1V2.50018M14 1V2.5M14 2.5H4C2.34315 2.5 1 3.84315 1 5.5V15.5001C1 17.1569 2.34315 18.5001 4 18.5001H14C15.6569 18.5001 17 17.1569 17 15.5001L17 5.5C17 3.84315 15.6569 2.5 14 2.5Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClaendarIcon);
export default __webpack_public_path__ + "static/media/claendarIcon.5730be228384518554777db1742204b2.svg";
export { ForwardRef as ReactComponent };